const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico']);
const PDF_EXTENSIONS = new Set(['pdf']);
const VIDEO_EXTENSIONS = new Set(['mp4', 'mov', 'avi', 'webm', 'mkv']);

function getExtension(fileName: string): string {
    const dot = fileName.lastIndexOf('.');
    if (dot < 0) return '';
    return fileName.slice(dot + 1).toLowerCase();
}

export function isImageFile(fileName: string): boolean {
    return IMAGE_EXTENSIONS.has(getExtension(fileName));
}

export function isPdfFile(fileName: string): boolean {
    return PDF_EXTENSIONS.has(getExtension(fileName));
}

export function isVideoFile(fileName: string): boolean {
    return VIDEO_EXTENSIONS.has(getExtension(fileName));
}

export function getFileCategory(fileName: string): 'image' | 'pdf' | 'video' | 'other' {
    if (isImageFile(fileName)) return 'image';
    if (isPdfFile(fileName)) return 'pdf';
    if (isVideoFile(fileName)) return 'video';
    return 'other';
}
